import { Note } from "@onpreo/database/src/definitions/note";

export type NoteState = Note[];
export const initialNoteState = [] as NoteState;
